/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { GENERATE_SECTION_DESCRIPTION, PUBLISH_STATUS } from 'utils/const';

const initialState = {
  selectedModelYear: new Date().getFullYear(),
  isSourceFilesSectionCollapsed: false,
  generateFilesSectionDescription: GENERATE_SECTION_DESCRIPTION,
  // SOURCE FILES START
  vinFile: {},
  // SOURCE FILES END
  haveAllSourceFiles: false,
  // GENERATED FILES START
  shouldOpenConfirmPublishModal: false,
  userFileAction: '',
  selectedFilesToGenerateOrUpdate: {},
  selectedFilesForPublishing: {},
  // PUBLISH FILES START
  publishOverviewFiles: [],
  // PUBLISH FILES END
};

const recallComplianceSlice = createSlice({
  name: 'recallCompliance',
  initialState,
  reducers: {
    setSelectedModelYear: (state, action) => {
      state.selectedModelYear = action.payload;
    },
    setIsSourceFilesSectionCollapsed: (state, action) => {
      state.isSourceFilesSectionCollapsed = action.payload;
    },
    toggleCollapseSourceFilesSection: (state) => {
      state.isSourceFilesSectionCollapsed =
        !state.isSourceFilesSectionCollapsed;
    },
    setVINFile: (state, action) => {
      state.vinFile = action.payload;
    },
    openGetEffectiveDatesModal: (state, action) => {
      const { selectedFilesToGenerateOrUpdate, userFileAction } =
        action.payload;
      state.shouldOpenGetEffectiveDatesModal = true;
      state.userFileAction = userFileAction;
      state.selectedFilesToGenerateOrUpdate = {
        ...state.selectedFilesToGenerateOrUpdate,
        ...selectedFilesToGenerateOrUpdate,
      };
    },
    closeGetEffectiveDatesModal: (state) => {
      state.shouldOpenGetEffectiveDatesModal = false;
      state.userFileAction = '';
      state.selectedFilesToGenerateOrUpdate = {};
    },
    updateFilePublishStatus: (state) => {
      const updatedVin = {
        ...state.vinFile,
        status: PUBLISH_STATUS.PUBLISHED,
      };
      state.vinFile = updatedVin;
    },
    setPublishOverviewFiles: (state, action) => {
      state.publishOverviewFiles = action.payload;
    },
    openConfirmPublishModal: (state, action) => {
      const { selectedFilesForPublishing, userFileAction } = action.payload;
      state.shouldOpenConfirmPublishModal = true;
      state.userFileAction = userFileAction;
      state.selectedFilesForPublishing = {
        ...state.selectedFilesForPublishing,
        ...selectedFilesForPublishing,
      };
    },
    closeConfirmPublishModal: (state) => {
      state.shouldOpenConfirmPublishModal = false;
      state.userFileAction = '';
      state.selectedFilesForPublishing = {};
    },
    publishVinInitiated: (state) => {
      const updatedVin = {
        ...state.vinFile,
        status: PUBLISH_STATUS.PROCESSING,
      };
      state.vinFile = updatedVin;
      state.publishOverviewFiles.push(updatedVin);
    },
  },
});

export default recallComplianceSlice.reducer;
export const {
  setSelectedModelYear,
  setIsSourceFilesSectionCollapsed,
  toggleCollapseSourceFilesSection,
  setIMDFile,
  setVINFile,
  setPriceMatrixFiles,
  setPPLFiles,
  updateFilePublishStatus,
  setPublishOverviewFiles,
  openConfirmPublishModal,
  closeConfirmPublishModal,
  publishVinInitiated,
} = recallComplianceSlice.actions;
